import { put, takeEvery } from 'redux-saga/effects';
import {
  startFetchForms,
  fetchFormsSuccess,
  fetchFormsFailure,
  FetchTiedApplicationsSuccess,
  FetchTiedApplicationsFailure,
  fetchSingleFormSuccess,
  fetchSingleFormFailure
} from 'redux/forms/actions';
import request from 'utils/request';
import urls from 'utils/config';
import FormsActionTypes from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { FORM_API_BASE_URL, API_BASE_URL } = urls || {};

export function* fetchForms({ payload }) {
  const url = `${FORM_API_BASE_URL}/designs?index=${
    +payload.currentPage || 0
  }&size=${+payload.pageSize || 10}`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(fetchFormsSuccess(response.raw));
  } else {
    networkErrorHandler(response?.statusCode, `Failed to Fetch Forms: ${response.message}`);
    yield put(fetchFormsFailure(response.message));
  }
}

export function* getForms() {
  yield takeEvery(FormsActionTypes.START_FETCH_FORMS, fetchForms);
}

export function* fetchTiedApplications() {
  const url = `${API_BASE_URL}/applications/forms`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(FetchTiedApplicationsSuccess(response.raw));
    yield put(startFetchForms({
      currentPage: 0,
      pageSize: 10,
    }));
  } else {
    yield put(FetchTiedApplicationsFailure(response.message));
  }
}

export function* getApplicationForms() {
  yield takeEvery(
    FormsActionTypes.START_FETCH_APPLICATIONS_FORMS,
    fetchTiedApplications
  );
}

export function* fetchSingleForm({ id }) {
  const url = `${FORM_API_BASE_URL}/designs/${id}`;
  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(fetchSingleFormSuccess(response.raw));
  } else {
    yield put(fetchSingleFormFailure(response.message));
  }
}

export function* onGetSingleForm() {
  yield takeEvery(
    FormsActionTypes.FETCH_SINGLE_FORM,
    fetchSingleForm
  );
}
